import {maskAccountNum} from '@principal/text-formatters';
import {BankAccountIdentityStatus} from '@digital-advice/ms-custodian-sdk';

const getDocumentRequests = (documentRequests) =>
  documentRequests.map(({id, documentType, docId}) => ({
    id,
    documentType,
    docId,
  }));

const getIdentityRequests = (identityRequests) => {
  // Most recent updated date first
  identityRequests.sort((a, b) => (a.updatedDate < b.updatedDate ? 1 : -1));
  const requests = [];

  identityRequests.forEach((identityRequest) => {
    const newRequest = {
      id: identityRequest.id,
      statusId: identityRequest.statusId,
      status: identityRequest.status,
      documentRequests: getDocumentRequests(identityRequest.documentRequests),
    };

    requests.push(newRequest);
  });

  return requests;
};

const getBankAccount = (bankAccount, linkedCustodianAccounts, identityRequests, microDepositRequests) => {
  const sortedIdentityRequests = getIdentityRequests(identityRequests);

  return {
    id: bankAccount.id,
    bankName: bankAccount.bankName,
    bankAccountType: bankAccount.bankAccountType,
    bankRoutingNumber: bankAccount.bankRoutingNumber,
    bankAccountNumber: bankAccount.bankAccountNumber,
    formattedBankAccountNumber: maskAccountNum({
      accountNum: bankAccount.bankAccountNumberLastFour
        ? `XXXXXXXXXXXX${bankAccount.bankAccountNumberLastFour}`
        : bankAccount.bankAccountNumber,
    }),
    linked: bankAccount.linked,
    disabled: bankAccount.disabled,
    identityRequestStatus:
      sortedIdentityRequests.length === 0 ? BankAccountIdentityStatus.Approved : sortedIdentityRequests[0].status,
    microDepositRequestStatus: microDepositRequests.length === 0 ? 'UNKNOWN' : microDepositRequests[0].verificationStatus,
    linkedCustodianAccountsCount:
      linkedCustodianAccounts.length === 0 ? null : linkedCustodianAccounts[0].linkedCustodianAccountsCount,

    identityRequests: sortedIdentityRequests,
    microDepositRequests,
  };
};

export const transformApiResponse = (
  linkedBankAccounts,
  linkedCustodianAccountsList,
  identityRequests,
  microDepositRequests = []
) => {
  const bankAccounts = [];

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  let i = 0;

  linkedBankAccounts.forEach((bankAccount) => {
    const newIdentityRequests = identityRequests.filter((request) => bankAccount.id === request.bankAccountId);
    const newMicroDepositRequests = microDepositRequests.filter((request) => bankAccount.id === request.bankAccountId);
    const custodianAccounts = linkedCustodianAccountsList.filter((request) => bankAccount.id === request.id);
    const newBankAccount = getBankAccount(bankAccount, custodianAccounts, newIdentityRequests, newMicroDepositRequests);

    // // Don't include expired or rejected in the response
    if (
      newBankAccount?.identityRequestStatus !== BankAccountIdentityStatus.Expired &&
      newBankAccount?.identityRequestStatus !== BankAccountIdentityStatus.Rejected
    ) {
      bankAccounts.push(newBankAccount);
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    i += 1;
  });

  return {
    bankAccounts,
  };
};

export default {
  transformApiResponse,
};
